import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import {Button, Layout} from 'antd';
import NavSearch from './NavSearch';
import {onMobileNavToggle, toggleCollapsedNav} from 'redux/actions/Theme';
import {NAV_TYPE_TOP, SIDE_NAV_COLLAPSED_WIDTH, SIDE_NAV_WIDTH,} from 'constants/ThemeConstant';
import utils from 'utils';
import NavProfile from './NavProfile';
import NavNotification from './NavNotification';
import {withRouter} from 'react-router-dom';
import MenuIcon from 'components/icons/Menu';
import DocumentationSearchInput from './NavSearch/DocumentationSearchInput';

const { Header } = Layout;

export const DocumentationHeaderNav = (props) => {
  const {
    navCollapsed,
    mobileNav,
    navType,
    headerNavColor,
    toggleCollapsedNav,
    onMobileNavToggle,
    isMobile,
    currentTheme,
    location,
  } = props;
  const [searchActive, setSearchActive] = useState(false);

  const onSearchClose = () => {
    setSearchActive(false);
  };

  const onToggle = () => {
    if (!isMobile) {
      toggleCollapsedNav(!navCollapsed);
    } else {
      onMobileNavToggle(!mobileNav);
    }
  };

  const isNavTop = navType === NAV_TYPE_TOP ? true : false;
  const mode = () => {
    if (!headerNavColor) {
      return utils.getColorContrast(
        currentTheme === 'dark' ? '#00000' : '#ffffff'
      );
    }
    return utils.getColorContrast(headerNavColor);
  };
  const navMode = mode();
  const getNavWidth = () => {
    if (isNavTop || isMobile) {
      return '0px';
    }
    if (navCollapsed) {
      return `${SIDE_NAV_COLLAPSED_WIDTH}px`;
    } else {
      return `${SIDE_NAV_WIDTH}px`;
    }
  };

  useEffect(() => {
    if (!isMobile) {
      onSearchClose();
    }
  }, [isMobile, location.pathname]);

  return (
    <Header
      className={`app-header ${navMode}`}
      style={{ backgroundColor: headerNavColor }}
    >
      <div className={`app-header-wrapper ${isNavTop ? 'layout-top-nav' : ''}`}>
        <div className="nav" style={{ width: `calc(100% - ${getNavWidth()})` }}>
          <div className="nav-left">
            <Button
              icon={<MenuIcon />}
              type="primary"
              style={{
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: 40,
                height: 40,
                minWidth: 40,
                minHeight: 40,
              }}
              onClick={onToggle}
            />
            <ul className="ant-menu ant-menu-root ant-menu-horizontal d-flex">
              <li
                className="ant-menu-item ant-menu-item-only-child"
                style={{ cursor: 'auto' }}
              >
                <DocumentationSearchInput mode={mode} isMobile={isMobile} />
              </li>
            </ul>
          </div>
          <div className="nav-right">
            <NavNotification />
            <NavProfile />
          </div>
          <NavSearch active={searchActive} close={onSearchClose} />
        </div>
      </div>
    </Header>
  );
};

const mapStateToProps = ({ theme }) => {
  const {
    navCollapsed,
    navType,
    headerNavColor,
    mobileNav,
    currentTheme,
    direction,
  } = theme;
  return {
    navCollapsed,
    navType,
    headerNavColor,
    mobileNav,
    currentTheme,
    direction,
  };
};

export default connect(mapStateToProps, {
  toggleCollapsedNav,
  onMobileNavToggle,
})(withRouter(DocumentationHeaderNav));
